class Cart {
  constructor() {
    jQuery(document.body).on('added_to_cart removed_from_cart', (e, fragments) => {
      window.$madUtil.updateFragments(fragments);
    });

    this.initActions();

    const sharedCartId = this.getUrlParameter('apply_cart');
    if (sharedCartId) {
      this.applySharedCart(sharedCartId);
    }
  }

  initActions() {
    jQuery(document.body).on('click', '.mad-cart .mad-cart__clear-button', this.clearCart.bind(this));
    jQuery(document.body).on('click', '.mad-cart .mad-cart__share-button', this.shareCart.bind(this));
    jQuery(document.body).on('click', '.mad-cart .mad-cart__item-remove', this.removeFromCart.bind(this));
  }

  // --- helper to show notice (only if messages exist) ---
  showNotice(message, type = 'info') {
    if (!message) return; // wenn keine message → keine notice

    let icon = 'info';
    if (type === 'error') icon = 'dismiss';
    if (type === 'success') icon = 'yes';
    if (type === 'warning') icon = 'warning';

    const noticeHtml = `
      <div class="mad-notice">
        <div class="mad-notice__icon">
          <span class="dashicons dashicons-${icon}"></span>
        </div>
        <div class="mad-notice__content">${message}</div>
      </div>
    `;

    jQuery('.mad-notice').remove();
    jQuery('.mad-cart').prepend(noticeHtml);
  }

  clearCart(e) {
    e.preventDefault();
    window.$madUtil.blockElement('.mad-cart', { icon: { size: 'large' } });

    jQuery.ajax({
      type: 'POST',
      url: mad_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'mad_clear_cart'),
      success: (response) => {
        if (response.fragments) {
          jQuery(document.body).trigger('removed_from_cart', [response.fragments]);
        }
        window.$madUtil.unblockElement('.mad-cart');
      },
      error: () => {
        window.$madUtil.unblockElement('.mad-cart');
        const messages = this.getMessages();
        this.showNotice(messages?.error_generic, 'error');
      },
      dataType: 'json',
    });
  }

  shareCart(e) {
    e.preventDefault();
    window.$madUtil.blockElement('.mad-cart', { icon: { size: 'large' } });
    const messages = this.getMessages();

    jQuery.ajax({
      type: 'POST',
      url: mad_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'mad_generate_share_cart_url'),
      data: { nonce: mad_cart_params.nonce },
      success: (response) => {
        window.$madUtil.unblockElement('.mad-cart');

        if (!response.success) {
          const msg = response.data?.message || messages?.error_generic;
          this.showNotice(msg, 'error');
          return;
        }

        jQuery('#mad-share-cart-url').val(response.data.url);
        window.openBrizyPopupByChild('.mad-share-cart-form');

        const msg = response.data.message || messages?.create_success;
        this.showNotice(msg, 'success');
      },
      error: () => {
        window.$madUtil.unblockElement('.mad-cart');
        this.showNotice(messages?.error_generic, 'error');
      },
      dataType: 'json',
    });
  }

  applySharedCart(sharedCartId) {
    window.$madUtil.blockElement('.mad-cart', { icon: { size: 'large' } });
    const messages = this.getMessages();

    jQuery.ajax({
      type: 'POST',
      url: mad_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'mad_apply_shared_cart'),
      data: { shared_cart_id: sharedCartId, nonce: mad_cart_params.nonce },
      success: (response) => {
        window.$madUtil.unblockElement('.mad-cart');

        if (response.success && response.data.fragments) {
          window.$madUtil.updateFragments(response.data.fragments);
          this.removeUrlParameter('apply_cart');

          if (response.data.failed_items?.length) {
            const failedItems = response.data.failed_items.join(', ');
            this.showNotice(messages?.apply_partial?.replace('%s', failedItems), 'warning');
          } else {
            this.showNotice(messages?.apply_success, 'success');
          }
        } else {
          const msg = response.data?.message || messages?.apply_failed;
          this.showNotice(msg, 'error');
        }
      },
      error: () => {
        window.$madUtil.unblockElement('.mad-cart');
        this.showNotice(messages?.error_generic, 'error');
      },
      dataType: 'json',
    });
  }

  copyShareCartUrl() {
    const urlField = jQuery('#mad-share-cart-url');
    const successText = jQuery('.mad-share-cart-form__success-text');
    window.$madUtil.copyToClipboard(urlField.val());
    successText.addClass('active');
    setTimeout(() => successText.removeClass('active'), 5000);
  }

  removeFromCart(e) {
    e.preventDefault();
    const button = jQuery(e.target).closest('.mad-cart__item-remove > a');
    window.$madUtil.blockElement('.mad-cart', { icon: { size: 'large' } });

    jQuery.ajax({
      type: 'POST',
      url: wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'remove_from_cart'),
      data: { cart_item_key: button.data('cart_item_key') },
      success: (response) => {
        if (!response?.fragments) {
          window.location = button.attr('href');
          return;
        }
        jQuery(document.body).trigger('removed_from_cart', [response.fragments, response.cart_hash, button]);
        window.$madUtil.unblockElement('.mad-cart');
      },
      error: () => { window.location = button.attr('href'); },
      dataType: 'json'
    });
  }

  getUrlParameter(name) {
    const url = window.location.search.substring(1);
    const urlVariables = url.split('&');
    for (let i = 0; i < urlVariables.length; i++) {
      const parameter = urlVariables[i].split('=');
      if (parameter[0] === name) return parameter[1];
    }
    return false;
  }

  removeUrlParameter(param) {
    const url = window.location.href;
    const regex = new RegExp(`[&?]${param}=([^&#]*)`, 'i');
    const cleanUrl = url.replace(regex, '');
    history.replaceState(null, null, cleanUrl);
  }

  // --- helper: get messages from $madSettings safely ---
  getMessages() {
    return window.$madSettings?.shop?.shareCart?.messages || null;
  }
}

module.exports = Cart;
